import { Component } from 'react'
import { connect } from 'react-redux';
import RouletteLeft from "./RouletteLeft";
import RouletteRight from "./RouletteRight";
import { gameActions } from '../../action/GameAction';
import Countdown, { zeroPad } from 'react-countdown';
import Header from "../../Header/Header";
import { withTranslation } from 'react-i18next';
import { accountActions } from '../../action/AccountAction';
import RouletteAnimation from './RouletteAnimation';
import HomeSlidTabs from '../Home/HomeSlidTabs';
let ToTalCount = 0;
window.clearInsRoulBall = 1

class Roulette extends Component {
	constructor(props) {
		super(props);
		this.state = {
			cartItems: [],
			currentRunningDraw: {},
			currentFinishingDraw: {},
			coundownStart: 0,
			coundTime: 18900000,
			currentDraw: {},
			currentAvailableDraws: [],
			currentCartItem: { id: 0, ballNo: "", stakeValue: 100, oddsValue: 0, total: 0, gameName: "", drawDateTime: "", drawID: 0, drawNo: 0, gameID: 0, gameGroupID: 0 },

			ballStartNumber: 0,
			ballEndNumber: 0,
			QPBallCount: 0,
			random: [],
			showSingleMsg: false,
			_serverTimeDiff: 0,
			allGameClosed: 0,
			isViewAnimation: false,
			webglInit: false,
			timerGetResult: null,
			timerGetLatestResult: null,
			timerGetResultCount: 0,
			servertt: 0,
			gameGroupID: 40
		};
		this.my_componentWillUnmount();
		if (this.state.gameGroupID !== undefined && this.state.servertt == 0) {
			this.state.servertt = props.serverTime;
			setTimeout(() => { this.props.GetRouletteResult(this.state.gameGroupID, this.props.user.mobileNo, 0, 0) }, 1000)
		}
		props.GameAvailableGamesRoulete(props.user.mobileNo, this.state.gameGroupID, props.i18n.language, this.state.servertt);
		//setTimeout(() => { this.props.GetRouletteResult(this.state.gameGroupID, this.props.user.mobileNo, 0, 0) }, 1000)
	}

	static getDerivedStateFromProps(props, state) {
		return {
			currentAvailableDraws: props.currentAvailableDraws,
			cartItems: props.cartItems,
			currentDraw: props.currentDraw,
			latestRouletteResult: props.latestRouletteResult,
			currentResult: props.currentResult
		};
	};

	showSingleMsg = false;
	//{ "Id": key, "BallNo": no, "DispName": _dispName, "BallCount": _ballcount,
	// "GameGroupID": objSelectedDraw.GameGroupId, "SubGameID": objSelectedDraw.SubGameID,
	// "DrawNo": objSelectedDraw.DrawNo, "GameId": objSelectedDraw.GameId,
	// "GameName": objSelectedDraw.GameName, "GameTime": objSelectedDraw.Drawdatetime, 
	//"OddsValue": _oddsValue, "StakeValue": stakeval, "SubTotal": (stakeval * _oddsValue).toFixed(2) };
	selectBall = (bet, update) => {
		if (bet == undefined) {
			this.clearCart();
			return;
		}
		let b_id = bet.Id;
		if (this.state.currentDraw == null || Object.keys(this.state.currentDraw).length == 0) { this.state.showSingleMsg = true; alert("Please select the draw1"); return; }
		let obj = this.state.cartItems.filter(x => x.id == b_id);
		if (update && obj.length > 0) {
			obj = obj[0]
			obj.stakeValue = bet.StakeValue;
			obj.total = bet.SubTotal;
			this.props.UpdateCartAll(obj);
		}
		else if (obj.length > 0) {
			this.props.RemoveFromCart(b_id);
		}
		else {
			//let objLst = { id: 0, ballNo: "", stakeValue: 100, oddsValue: 0, total: 0, gameName: "", drawDateTime: "", drawID: 0, drawNo: 0, gameID: 0, gameGroupID: 0, minStake: 0, maxStake: 0, multiStake: 0 };
			let objLst = {};
			objLst.stakeValue = bet.StakeValue;
			objLst.gameName = this.state.currentDraw.LotName;
			objLst.drawID = this.state.currentDraw.DrawID;
			objLst.drawNo = this.state.currentDraw.DrawNo;
			objLst.gameID = this.state.currentDraw.GameId;
			objLst.drawDateTime = this.state.currentDraw.DrawDate + " " + this.state.currentDraw.DrawTime;
			objLst.drawTime = this.state.currentDraw.DrawTime;
			objLst.ballNo = bet.BallNoID;//bet.BallNo;
			objLst.dispName = bet.DispName;
			objLst.id = b_id;
			objLst.oddsValue = bet.OddsValue;
			objLst.total = bet.SubTotal;
			objLst.gameGroupID = this.state.gameGroupID
			let newid = 1;
			if (this.state.cartItems.length > 0) {
				newid = this.state.cartItems.reduce((max, b) => Math.max(max, b.bMax), this.state.cartItems[0].bMax);
			}
			objLst.bMax = newid + 1;
			this.props.AddToCartRoulette(objLst);
		}
	};

	selectDraw = (_draw) => {
		window.DeleteAllBetSlip();
		this.props.SetCurrentDraw(_draw);
	};

	selectRunningDraw = () => {
		if (this.state.coundownStart != undefined && this.state.coundownStart == 0) {
			//if (this.state.currentFinishingDraw != undefined && this.state.currentAvailableDraws.length > 0) {
			if (this.state.currentFinishingDraw != undefined) {
				//if (this.state.currentFinishingDraw.DrawID == undefined || this.state.currentRunningDraw.DrawID == undefined || this.state.currentFinishingDraw.DrawID !=this.state.currentRunningDraw.DrawID) {
				let lst = this.state.currentAvailableDraws.filter(a => a.DrawID == this.state.currentFinishingDraw.DrawID);
				if (lst.length > 0 || this.state.currentAvailableDraws.length <= 0) {
					let _draw = this.state.currentAvailableDraws[0];
					//let _draw = lst[0];
					this.setState({
						currentRunningDraw: _draw,
					})
					this.state.currentRunningDraw = _draw;
					this.selectDraw(_draw);
				}
				else {
					return;
				}
			}

			// if (this.state.currentFinishingDraw != undefined && this.state.currentAvailableDraws.length > 0) {
			// 	let lst = this.state.currentAvailableDraws.filter(a => a.DrawID == this.state.currentFinishingDraw.DrawID);
			// 	if (lst.length > 0) {
			// 		return;
			// 	}
			// }

			let _draw = this.state.currentAvailableDraws[0];
			if (_draw == undefined) { this.state.coundownStart = 1; return; }
			try {
				let sTime = undefined; //new Date(Date.now() - this.state.coundTime);
				if (_draw != undefined) {
					var pattern = /(\d{2})\/(\d{2})\/(\d{4})/;
					let ss = new Date(_draw.DrawDateTime.replace(pattern, '$3-$2-$1').replace(/-/g, '/'));
					sTime = new Date(ss.setSeconds(ss.getSeconds() - 60));
				}
				let dStr = ("0" + sTime.getDate()).slice(-2) + "/" + ("0" + (sTime.getMonth() + 1)).slice(-2) + "/" + sTime.getFullYear() + " " + sTime.getHours() + ":" + sTime.getMinutes() + ":" + sTime.getSeconds();
				window.timer = null;
				this.state.coundownStart = window.startDraw(dStr, this.RefreshAfterGameClose);
			}
			catch (ex) {
				alert(ex);
			}
		}
	};

	componentDidUpdate(previousProps, previousState) {
		window.objCurrentDraw = this.state.currentRunningDraw;
		window.objResultDraw = this.state.currentFinishingDraw;
		window.objSelectedDraw = this.state.currentDraw;

		if ((previousState.currentResult != this.state.currentResult) || (this.state.currentResult && this.state.currentResult.indexOf("1~") == 0)) {
			console.log("start startAnimationWebGL in componentDidUpdate with : " + this.state.currentResult);
			this.startAnimationWebGL();
		}
		if (this.state.currentAvailableDraws.length > 0 && ((this.state.currentRunningDraw == null || Object.keys(this.state.currentRunningDraw).length <= 0) || this.state.currentAvailableDraws[0].DrawNo != this.state.currentRunningDraw.DrawNo))
		//if ((this.state.currentRunningDraw == null || Object.keys(this.state.currentRunningDraw).length == 0) && (this.state.allGameClosed == 0))
		{
			if (this.state.currentAvailableDraws == undefined || this.state.currentAvailableDraws.length <= 0) {
				this.state.allGameClosed = 1
			}
			let _draw = this.state.currentAvailableDraws ? this.state.currentAvailableDraws[0] : null;
			this.selectDraw(_draw);
			this.state.currentRunningDraw = _draw;
			this.setState({ currentRunningDraw: _draw });
			if (this.state.webglInit == false && this.state.currentRunningDraw) {
				this.setWelcomScreenWebGL();
				this.state.webglInit = true;
			}
		}
		this.RefetcData()
	};
	RefetcData = () => {
		if (!this.state.currentAvailableDraws || ToTalCount < 2) {
			ToTalCount++;
			let RefetchData = setInterval(() => {
				this.props.GameAvailableGamesRoulete(this.props.user.mobileNo, this.state.gameGroupID, this.props.i18n.language, this.props.serverTime);
				clearInterval(RefetchData)
			}, (2000 * ToTalCount));
		}
	}
	componentDidMount() {
		window.addEventListener('resize', window.documentReadyResize);
		window.spancanvas();
		window.updateFromJS(this.updateFromJS)
	};
	my_componentWillUnmount = () => {
		this.props.ClearCart();
		this.setState({
			currentRunningDraw: null,
		})
		this.props.ClearAvailableGames();
	};

	RefreshAfterGameClose = () => {
		if (this.state.currentFinishingDraw.DrawDateTime == this.state.currentRunningDraw.DrawDateTime) {
			return;
		}
		//alert("coundown finish");
		this.state.coundownStart = 0;
		this.state._serverTimeDiff = 0;
		this.state.currentFinishingDraw = this.state.currentRunningDraw;

		this.props.RemoveClosedDrawbetFromCart(this.state.currentFinishingDraw.DrawID);
		setTimeout(() => { this.props.GameAvailableGamesRoulete(this.props.user.mobileNo, this.state.gameGroupID, this.props.i18n.language, this.props.serverTime) }, 1000)
		this.props.GameAvailableGamesRoulete(this.props.user.mobileNo, this.state.gameGroupID, this.props.i18n.language, this.props.serverTime);
		this.state.currentRunningDraw = {};
		console.log("RefreshAfterGameClose drawID : " + this.state.currentFinishingDraw.GameId)
		this.state.timerGetResultCount = 0;
		// this.state.timerGetResult = setTimeout(() => { this.props.GetAllResult(this.state.currentFinishingDraw.DrawTime, 40, 1, this.props.user.loginKey) }, 5000);
		this.state.timerGetResult = setTimeout(() => { this.props.GetCurrentResultRoulete(this.state.currentFinishingDraw.DrawTime, 40, this.state.currentFinishingDraw.DrawID, this.props.i18n.language, this.props.user.loginKey) }, 5000);

	};

	setWelcomScreenWebGL = () => {
		if (this.state.currentRunningDraw && this.state.currentRunningDraw.DrawDateTime) {
			var s = this.state.currentRunningDraw.DrawDateTime.split(' ');
			var strkey = "ThOtArPuElLaThA~0~" + this.state.currentRunningDraw.DrawNo + "~" + s[0] + "~" + s[1] + "~" + this.state.currentRunningDraw.LotName + "~0~00:00 AM";
			//let strkey = "ThOtArPuElLaThA~7~12~11/11/11~11:00 AM~Test~2";
			console.log("start setWelcomScreenWebGL");
			this.fnWelcome(strkey);
		}
	}
	startAnimationWebGL = () => {
		//alert("call animate");
		//this.state.currentResult="0~1~142~05/09/2021~10:00 AM~Quick Win~9";
		if (this.state.currentResult) {
			let arr = this.state.currentResult.split("~");
			if (arr[0] == "0") {
				//var s = this.state.currentRunningDraw.Drawdatetime.split(' ');
				//var strkey = "ThOtArPuElLaThA~" + this.state.currentRunningDraw.GameName + "~" + this.state.currentRunningDraw.GameID + "~" + s[0] + "~" + s[1] + "";
				let strkey = "ThOtArPuElLaThA~" + this.state.currentResult.substring(2, this.state.currentResult.length);
				var s = this.state.currentDraw ? this.state.currentDraw.DrawTime : "No More";
				if (s != null) {
					strkey = strkey + "~" + s;
				}
				else {
					strkey = strkey + "~00:00";
				}
				console.log("start startAnimationWebGL with : " + strkey);
				this.viewAnimationResult(1);
				this.fnStartAnimation(strkey);
				clearTimeout(this.state.timerGetResult);
				this.state.timerGetResult = null;
				this.state.timerGetResultCount = 0;
				let mythis = this;
				this.state.timerGetLatestResult = setTimeout(() => { mythis.props.GetRouletteResult(mythis.state.gameGroupID, mythis.props.user.mobileNo, 0, 0) }, 30000);
			}
			else {
				if (this.state.timerGetResultCount < 5) {
					if (this.state.timerGetResult != null) {
						return;
					}
					else {
						this.state.timerGetResultCount++;
					}
					console.log("GetCurrentResult drawID : " + this.state.currentFinishingDraw.GameId)
					let mythis = this;
					this.state.timerGetResult = setTimeout(() => {
						clearTimeout(mythis.state.timerGetResult);
						mythis.state.timerGetResult = null;
						mythis.props.GetCurrentResultRoulete(mythis.state.currentFinishingDraw.DrawTime, 40, mythis.state.currentFinishingDraw.DrawID, 1, mythis.props.user.loginKey)
					}, 2000);
				}

				//	setTimeout(this.startAnimationWebGL(), 3000);
			}
		}
		else {
			//	this.props.GetCurrentResult(this.state.currentDraw.DrawNo)
			//	setTimeout(this.startAnimationWebGL(), 3000);
		}
	}

	fnWelcome = () => {
	}
	fnStartAnimation = () => {
	}
	viewAnimationResult = (flog) => {
		if (flog == 1 && this.state.isViewAnimation == true) {
			return;
		}
		this.setState({ isViewAnimation: !this.state.isViewAnimation });
	}
	clearAfterAddToCart = () => {
		window.DeleteExpiredGameBetSlip(true);
		// let obj = this.state.cartItems.filter(x => x.gameID == this.state.currentDraw.GameId);
		// for (let i = 0; i < obj.length; i++) {
		// 	this.props.RemoveFromCart(obj[i].id);
		// }
		this.setState({
			random: [],
			QPBallCount: 0
		});
	};

	clearCart = () => {
		this.props.ClearCart();
		this.setState({
			random: [],
			QPBallCount: 0
		});
	};

	removeFromCart = (cid) => {
		this.props.RemoveFromCart(cid);
	};

	countdownCompleted = () => {
		this.RefreshAfterGameClose();
	};

	getGameTime = () => {
		let _date = this.state.currentRunningDraw ? this.state.currentRunningDraw.DrawDateTime : "";
		if (_date != undefined && _date != "") {
			var pattern = /(\d{2})\/(\d{2})\/(\d{4})/;
			let sTime = (new Date(_date.replace(pattern, '$3-$2-$1').replace(/-/g, '/')).getTime());
			console.log("getGameTime : " + sTime);
			console.log("DateNow : " + Date.now());
			return sTime;
		}
		else {
			return 0;
		}
	};

	// Renderer callback with condition
	renderer = ({ total, days, hours, minutes, seconds, completed }) => {
		if (completed) {
			// Render a completed state			
			return <span>Draw Closed!</span>;
		} else {
			// Render a countdown
			return <span>{zeroPad(total)}:{zeroPad(days)}:{zeroPad(hours)}:{zeroPad(minutes)}:{zeroPad(seconds)}</span>;
		}
	};

	reCount = (rundraw) => {
		if (this.state.currentDraw == null || rundraw == null || Object.keys(rundraw).length == 0) {

			return <span></span>;
		}
		else {
			this.state.coundownStart = 1;
			return <span key={rundraw.DrawID}><Countdown now={() => { return (this.props.serverTime); }} date={this.getGameTime()} onComplete={this.countdownCompleted} renderer={({ days, hours, minutes, seconds, completed }) => { return (completed ? <div>{this.props.t('lblDrawClosed')}</div> : <> {zeroPad((days * 24) + hours)}:{zeroPad(minutes)}:{zeroPad(seconds)}</>) }} /> </span>;
		}
	};

	BuyLotteryBet = () => {
		if (this.props.user == undefined || this.props.user.mobileNo == "0") {
			alert(this.props.t('lblLoginValidation'));
			return;
		}
		if (this.state.cartItems == undefined || this.state.cartItems.length <= 0) {
			alert(this.props.t('lblplcurbet'));
			return;
		}
		let totStake = this.state.cartItems.reduce((a, b) => a = a + b.stakeValue, 0);
		let minTotStake = 500;
		let maxTotStake = 10000;
		if (this.state.currentRunningDraw != undefined) {
			minTotStake = this.state.currentRunningDraw.minStake //this.state.currentGamesFamily.minStakePerTrans;
			maxTotStake = this.state.currentRunningDraw.maxStake//this.state.currentGamesFamily.maxStakePerTrans;
		}
		if (totStake < minTotStake) //300
		{
			alert(this.props.t('lblMinimumplayAmt') + " : " + minTotStake);
			return;
		}
		else if (totStake > maxTotStake) //10000
		{
			alert(this.props.t('lblMaximumplayAmt') + " : " + maxTotStake);
			return;
		}
		var sTime = new Date(this.props.serverTime);
		let cartList = this.state.cartItems.sort((a, b) => a.drawID - b.drawID);
		let gamestring = "";
		let inx = 1;
		cartList.forEach(item => {
			gamestring += inx;
			gamestring += "~" + item.ballNo;
			gamestring += "~" + item.oddsValue;
			gamestring += "~" + (item.stakeValue * 100);
			gamestring += "~" + item.total + "|";
		})
		let TransID = ("0" + sTime.getDate()).slice(-2) + ("0" + (sTime.getMonth() + 1)).slice(-2) + sTime.getFullYear() + ("0" + sTime.getHours()).slice(-2) + ("0" + sTime.getMinutes()).slice(-2) + ("0" + sTime.getSeconds()).slice(-2) + this.props.user.mobileNo.substring(this.props.user.mobileNo.length - 4);
		let ObjBuy = {
			"reflot": this.state.cartItems[0].gameID,
			"group_id": parseInt(this.state.cartItems[0].gameGroupID),
			"draw_time": this.state.cartItems[0].drawTime,
			"bet_info": gamestring,
			"client_transid": TransID,
			"amount": totStake * 100,
			"type_id": 0
		}
		this.props.BuybetRoulete(ObjBuy, this.props.user.mobileNo, 1, this.props.user.loginKey);
		this.clearAfterAddToCart();
	};

	updateFromJS = (slp, update) => {
		this.selectBall(slp, update);

	}

	render() {
		const { t } = this.props;
		return (
			<>
				<Header />
				<div className="gameContainer">
					<HomeSlidTabs />
					<div className="lottoLft">
						{/* <div className="drawTabs">
								<a className="" id="drawTabs1">{t('lblAllDraws')}</a>
								<a className="" id="drawTabs2">{t('lbllatresult')}</a>
								<a class="" id="virtualbetSlipBtn">{t('lblgameslip')} <span class="betCount">{this.state.cartItems.length}</span></a>
							</div>
							<div class="drawTabs1024">
								<a class="" id="drawTabs3">{t('lblAllDraws')}</a>
							</div> */}

						<div class="rteWrap margin-top-20">
							<div class="rouletteCont">
								<div class="rouletteContTop">
									<div class="rouletteContTopLi">
										<div class="rouletteContName">Roulette</div>
									</div>
									<div class="nextDrawTimer">
										<div class="nextDrawLbl">Next Draw</div>
										<div class="nextDrawNoAndTimer">
											<span>#{this.state.currentDraw ? this.state.currentDraw.DrawNo : ''}</span>
											<span>{this.reCount(this.state.currentRunningDraw)}</span>
										</div>
										<div class="nextDrawProgBar">
											<div class="circle-container" data-progress="50">
												<svg class="progress-ring" width="40" height="40">
													<circle class="progress-ring__track" cx="20" cy="20" r="15"></circle>
													<circle class="progress-ring__progress" cx="20" cy="20" r="15"></circle>
												</svg>
											</div>
										</div>
									</div>

									<div class="rouletteContTopLi">
										<p>Date Time:</p>
										<span>{this.state.currentDraw ? this.state.currentDraw.DrawDateTime : '-'}</span>
									</div>
									<div class="rouletteContTopLi">
										{/* <a ><img src="./assets/img/roulette/award-pro.png" /><span>Awards Program</span></a>  */}
									</div>
									<div class="rouletteContTopLi">
										{/* <a ><img src="./assets/img/roulette/htp.png" /><span>How to play</span></a>  */}
									</div>
								</div>
								<div class="rouletteContTop">
									<div class="rouletteContTopLft">

									</div>
								</div>
								{/* <div class="gameTop">
								<h2 class="title5">Roulette</h2>
								<a id="eyeIcon" onClick={() => { this.viewAnimationResult() }} >{this.state.isViewAnimation ? t('lblHide') : t('lblShow')}</a>
							</div> */}
								{/* <div class="animateSec border-color" style={{ display: this.state.isViewAnimation ? "block" : "none" }}>
								<WebGLApp fnWelcome={(dd) => { this.fnWelcome = dd; }} fnStartAnimation={(dd) => { this.fnStartAnimation = dd; }} />
							</div> */}
								<div class="rouletteGameSec">
									<div class="rouletteGameCont">
										<RouletteAnimation fnWelcome={(dd) => { this.fnWelcome = dd; }} fnStartAnimation={(dd) => { this.fnStartAnimation = dd; }} />
										{/* <div class="rouletteWheel">
											<WebGLApp fnWelcome={(dd) => { this.fnWelcome = dd; }} fnStartAnimation={(dd) => { this.fnStartAnimation = dd; }} />
										</div> */}
										<div class="rlttePlay">
											<div class="rlttePlaySec animated zoomIn" id="panLottoBalls">
												<div class="rltteGameCont">
													<div class="rteBalContLft">
														<div class="rteBalContLftBall" id="rouletteBall-00">
															<canvas class="rteClickEventTop" id="obj_00" data-refid="rouletteBall-00"></canvas>
															<canvas class="rteClickEventLftInLft" data-refid="rouletteBall-00"></canvas>
															<canvas class="rteClickEventBtom" data-refid="rouletteBall-00"></canvas>
															<span class="rteBallValLftInLft animated zoomIn" data-refid="rouletteBall-00">0</span>
														</div>
													</div>
													<div class="rteBalContCent">
														<div class="rouletteBall bgRed" id="rouletteBall-03">
															<canvas class="rteClickEventTop" id="obj_03" data-refid="rouletteBall-03"></canvas>
															<canvas class="rteClickEventRht" id="obj_03_06" data-refid="rouletteBall-03~rouletteBall-06"></canvas>
															<canvas class="rteClickEventLft" id="obj_00_03" data-refid="rouletteBall-00~rouletteBall-03"></canvas>
															<canvas class="center1ForBall0" id="obj_00_02_03" data-refid="rouletteBall-00~rouletteBall-02~rouletteBall-03"></canvas>
															<canvas class="Roucenter" id="obj_02_03_05_06" data-refid="rouletteBall-02~rouletteBall-03~rouletteBall-05~rouletteBall-06"></canvas>
															<span class="rteBallVal" data-refid="rouletteBall-03">3</span>
														</div>
														<div class="rouletteBall bgBlck" id="rouletteBall-06">
															<canvas class="rteClickEventTop" id="obj_06" data-refid="rouletteBall-06"></canvas>
															<canvas class="rteClickEventRht" id="obj_06_09" data-refid="rouletteBall-06~rouletteBall-09"></canvas>
															<canvas class="Roucenter" id="obj_05_06_08_09" data-refid="rouletteBall-05~rouletteBall-06~rouletteBall-08~rouletteBall-09"></canvas>
															<span class="rteBallVal animated zoomIn" data-refid="rouletteBall-06">6</span>
														</div>
														<div class="rouletteBall bgRed" id="rouletteBall-09">
															<canvas class="rteClickEventTop" id="obj_09" data-refid="rouletteBall-09"></canvas>
															<canvas class="rteClickEventRht" id="obj_09_12" data-refid="rouletteBall-09~rouletteBall-12"></canvas>
															<canvas class="Roucenter" id="obj_08_09_11_12" data-refid="rouletteBall-08~rouletteBall-09~rouletteBall-11~rouletteBall-12"></canvas>
															<span class="rteBallVal animated zoomIn" data-refid="rouletteBall-09">9</span>
														</div>
														<div class="rouletteBall bgRed" id="rouletteBall-12">
															<canvas class="rteClickEventTop" id="obj_12" data-refid="rouletteBall-12"></canvas>
															<canvas class="rteClickEventRht" id="obj_12_15" data-refid="rouletteBall-12~rouletteBall-15"></canvas>
															<canvas class="Roucenter" id="obj_11_12_14_15" data-refid="rouletteBall-11~rouletteBall-12~rouletteBall-14~rouletteBall-15"></canvas>
															<span class="rteBallVal animated zoomIn" data-refid="rouletteBall-12">12</span>
														</div>
														<div class="rouletteBall bgBlck" id="rouletteBall-15">
															<canvas class="rteClickEventTop" id="obj_15" data-refid="rouletteBall-15"></canvas>
															<canvas class="rteClickEventRht" id="obj_15_18" data-refid="rouletteBall-15~rouletteBall-18"></canvas>
															<canvas class="Roucenter" id="obj_14_15_17_18" data-refid="rouletteBall-14~rouletteBall-15~rouletteBall-17~rouletteBall-18"></canvas>
															<span class="rteBallVal animated zoomIn" data-refid="rouletteBall-15">15</span>
														</div>
														<div class="rouletteBall bgRed" id="rouletteBall-18">
															<canvas class="rteClickEventTop" id="obj_18" data-refid="rouletteBall-18"></canvas>
															<canvas class="rteClickEventRht" id="obj_18_21" data-refid="rouletteBall-18~rouletteBall-21"></canvas>
															<canvas class="Roucenter" id="obj_17_18_20_21" data-refid="rouletteBall-17~rouletteBall-18~rouletteBall-20~rouletteBall-21"></canvas>
															<span class="rteBallVal animated zoomIn" data-refid="rouletteBall-18">18</span>
														</div>
														<div class="rouletteBall bgRed" id="rouletteBall-21">
															<canvas class="rteClickEventTop" id="obj_21" data-refid="rouletteBall-21"></canvas>
															<canvas class="rteClickEventRht" id="obj_21_24" data-refid="rouletteBall-21~rouletteBall-24"></canvas>
															<canvas class="Roucenter" id="obj_20_21_23_24" data-refid="rouletteBall-20~rouletteBall-21~rouletteBall-23~rouletteBall-24"></canvas>
															<span class="rteBallVal animated zoomIn" data-refid="rouletteBall-21">21</span>
														</div>
														<div class="rouletteBall bgBlck" id="rouletteBall-24">
															<canvas class="rteClickEventTop" id="obj_24" data-refid="rouletteBall-24"></canvas>
															<canvas class="rteClickEventRht" id="obj_24_27" data-refid="rouletteBall-24~rouletteBall-27"></canvas>
															<canvas class="Roucenter" id="obj_23_24_26_27" data-refid="rouletteBall-23~rouletteBall-24~rouletteBall-26~rouletteBall-27"></canvas>
															<span class="rteBallVal animated zoomIn" data-refid="rouletteBall-24">24</span>
														</div>
														<div class="rouletteBall bgRed" id="rouletteBall-27">
															<canvas class="rteClickEventTop" id="obj_27" data-refid="rouletteBall-27"></canvas>
															<canvas class="rteClickEventRht" id="obj_27_30" data-refid="rouletteBall-27~rouletteBall-30"></canvas>
															<canvas class="Roucenter" id="obj_26_27_29_30" data-refid="rouletteBall-26~rouletteBall-27~rouletteBall-29~rouletteBall-30"></canvas>
															<span class="rteBallVal animated zoomIn" data-refid="rouletteBall-27">27</span>
														</div>
														<div class="rouletteBall bgRed" id="rouletteBall-30">
															<canvas class="rteClickEventTop" id="obj_30" data-refid="rouletteBall-30"></canvas>
															<canvas class="rteClickEventRht" id="obj_30_33" data-refid="rouletteBall-30~rouletteBall-33"></canvas>
															<canvas class="Roucenter" id="obj_29_30_32_33" data-refid="rouletteBall-29~rouletteBall-30~rouletteBall-32~rouletteBall-33"></canvas>
															<span class="rteBallVal animated zoomIn" data-refid="rouletteBall-30">30</span>
														</div>
														<div class="rouletteBall bgBlck" id="rouletteBall-33">
															<canvas class="rteClickEventTop" id="obj_33" data-refid="rouletteBall-33"></canvas>
															<canvas class="rteClickEventRht" id="obj_33_36" data-refid="rouletteBall-33~rouletteBall-36"></canvas>
															<canvas class="Roucenter" id="obj_32_33_35_36" data-refid="rouletteBall-32~rouletteBall-33~rouletteBall-35~rouletteBall-36"></canvas>
															<span class="rteBallVal animated zoomIn" data-refid="rouletteBall-33">33</span>
														</div>
														<div class="rouletteBall bgRed" id="rouletteBall-36">
															<canvas class="rteClickEventTop" id="obj_36" data-refid="rouletteBall-36"></canvas>
															<canvas class="rteClickEventRht" data-refid="rouletteBall-36"></canvas>
															<span class="rteBallVal animated zoomIn" data-refid="rouletteBall-36">36</span>
														</div>


														<div class="rouletteBall bgBlck" id="rouletteBall-02">
															<canvas class="rteClickEventTop" id="obj_02_03" data-refid="rouletteBall-02~rouletteBall-03"></canvas>
															<canvas class="rteClickEventRht" id="obj_02_05" data-refid="rouletteBall-02~rouletteBall-05"></canvas>
															<canvas class="rteClickEventBtom" id="obj_01_02" data-refid="rouletteBall-01~rouletteBall-02"></canvas>
															<canvas class="rteClickEventLft" id="obj_00_02" data-refid="rouletteBall-00~rouletteBall-02"></canvas>
															<canvas class="center1ForBall0" id="obj_00_01_02" data-refid="rouletteBall-00~rouletteBall-01~rouletteBall-02"></canvas>
															<canvas class="Roucenter" id="obj_01_02_04_05" data-refid="rouletteBall-01~rouletteBall-02~rouletteBall-04~rouletteBall-05"></canvas>
															<span class="rteBallVal animated zoomIn" id="obj_02" data-refid="rouletteBall-02">2</span>
														</div>
														<div class="rouletteBall bgRed" id="rouletteBall-05">
															<canvas class="rteClickEventTop" id="obj_05_06" data-refid="rouletteBall-05~rouletteBall-06"></canvas>
															<canvas class="rteClickEventRht" id="obj_05_08" data-refid="rouletteBall-05~rouletteBall-08"></canvas>
															<canvas class="rteClickEventBtom" id="obj_04_05" data-refid="rouletteBall-04~rouletteBall-05"></canvas>
															<canvas class="Roucenter" id="obj_04_05_07_08" data-refid="rouletteBall-04~rouletteBall-05~rouletteBall-07~rouletteBall-08"></canvas>
															<span class="rteBallVal animated zoomIn" id="obj_05" data-refid="rouletteBall-05">5</span>
														</div>
														<div class="rouletteBall bgBlck" id="rouletteBall-08">
															<canvas class="rteClickEventTop" id="obj_08_09" data-refid="rouletteBall-08~rouletteBall-09"></canvas>
															<canvas class="rteClickEventRht" id="obj_08_11" data-refid="rouletteBall-08~rouletteBall-11"></canvas>
															<canvas class="rteClickEventBtom" id="obj_07_08" data-refid="rouletteBall-07~rouletteBall-08"></canvas>
															<canvas class="Roucenter" id="obj_07_08_10_11" data-refid="rouletteBall-07~rouletteBall-08~rouletteBall-10~rouletteBall-11"></canvas>
															<span class="rteBallVal animated zoomIn" id="obj_08" data-refid="rouletteBall-08">8</span>
														</div>
														<div class="rouletteBall bgBlck" id="rouletteBall-11">
															<canvas class="rteClickEventTop" id="obj_11_12" data-refid="rouletteBall-11~rouletteBall-12"></canvas>
															<canvas class="rteClickEventRht" id="obj_11_14" data-refid="rouletteBall-11~rouletteBall-14"></canvas>
															<canvas class="rteClickEventBtom" id="obj_10_11" data-refid="rouletteBall-10~rouletteBall-11"></canvas>
															<canvas class="Roucenter" id="obj_10_11_13_14" data-refid="rouletteBall-10~rouletteBall-11~rouletteBall-13~rouletteBall-14"></canvas>
															<span class="rteBallVal animated zoomIn" id="obj_11" data-refid="rouletteBall-11">11</span>
														</div>
														<div class="rouletteBall bgRed" id="rouletteBall-14">
															<canvas class="rteClickEventTop" id="obj_14_15" data-refid="rouletteBall-14~rouletteBall-15"></canvas>
															<canvas class="rteClickEventRht" id="obj_14_17" data-refid="rouletteBall-14~rouletteBall-17"></canvas>
															<canvas class="rteClickEventBtom" id="obj_13_14" data-refid="rouletteBall-13~rouletteBall-14"></canvas>
															<canvas class="Roucenter" id="obj_13_14_16_17" data-refid="rouletteBall-13~rouletteBall-14~rouletteBall-16~rouletteBall-17"></canvas>
															<span class="rteBallVal animated zoomIn" id="obj_14" data-refid="rouletteBall-14">14</span>
														</div>
														<div class="rouletteBall bgBlck" id="rouletteBall-17">
															<canvas class="rteClickEventTop" id="obj_17_18" data-refid="rouletteBall-17~rouletteBall-18"></canvas>
															<canvas class="rteClickEventRht" id="obj_17_20" data-refid="rouletteBall-17~rouletteBall-20"></canvas>
															<canvas class="rteClickEventBtom" id="obj_16_17" data-refid="rouletteBall-16~rouletteBall-17"></canvas>
															<canvas class="Roucenter" id="obj_16_17_19_20" data-refid="rouletteBall-16~rouletteBall-17~rouletteBall-19~rouletteBall-20"></canvas>
															<span class="rteBallVal animated zoomIn" id="obj_17" data-refid="rouletteBall-17">17</span>
														</div>
														<div class="rouletteBall bgBlck" id="rouletteBall-20">
															<canvas class="rteClickEventTop" id="obj_20_21" data-refid="rouletteBall-20~rouletteBall-21"></canvas>
															<canvas class="rteClickEventRht" id="obj_20_23" data-refid="rouletteBall-20~rouletteBall-23"></canvas>
															<canvas class="rteClickEventBtom" id="obj_19_20" data-refid="rouletteBall-19~rouletteBall-20"></canvas>
															<canvas class="Roucenter" id="obj_19_20_22_23" data-refid="rouletteBall-19~rouletteBall-20~rouletteBall-22~rouletteBall-23"></canvas>
															<span class="rteBallVal animated zoomIn" id="obj_20" data-refid="rouletteBall-20">20</span>
														</div>
														<div class="rouletteBall bgRed" id="rouletteBall-23">
															<canvas class="rteClickEventTop" id="obj_23_24" data-refid="rouletteBall-23~rouletteBall-24"></canvas>
															<canvas class="rteClickEventRht" id="obj_23_26" data-refid="rouletteBall-23~rouletteBall-26"></canvas>
															<canvas class="rteClickEventBtom" id="obj_22_23" data-refid="rouletteBall-22~rouletteBall-23"></canvas>
															<canvas class="Roucenter" id="obj_22_23_25_26" data-refid="rouletteBall-22~rouletteBall-23~rouletteBall-25~rouletteBall-26"></canvas>
															<span class="rteBallVal animated zoomIn" id="obj_23" data-refid="rouletteBall-23">23</span>
														</div>
														<div class="rouletteBall bgBlck" id="rouletteBall-26">
															<canvas class="rteClickEventTop" id="obj_26_27" data-refid="rouletteBall-26~rouletteBall-27"></canvas>
															<canvas class="rteClickEventRht" id="obj_26_29" data-refid="rouletteBall-26~rouletteBall-29"></canvas>
															<canvas class="rteClickEventBtom" id="obj_25_26" data-refid="rouletteBall-25~rouletteBall-26"></canvas>
															<canvas class="Roucenter" id="obj_25_26_28_29" data-refid="rouletteBall-25~rouletteBall-26~rouletteBall-28~rouletteBall-29"></canvas>
															<span class="rteBallVal animated zoomIn" id="obj_26" data-refid="rouletteBall-26">26</span>
														</div>
														<div class="rouletteBall bgBlck" id="rouletteBall-29">
															<canvas class="rteClickEventTop" id="obj_29_30" data-refid="rouletteBall-29~rouletteBall-30"></canvas>
															<canvas class="rteClickEventRht" id="obj_29_32" data-refid="rouletteBall-29~rouletteBall-32"></canvas>
															<canvas class="rteClickEventBtom" id="obj_28_29" data-refid="rouletteBall-28~rouletteBall-29"></canvas>
															<canvas class="Roucenter" id="obj_28_29_31_32" data-refid="rouletteBall-28~rouletteBall-29~rouletteBall-31~rouletteBall-32"></canvas>
															<span class="rteBallVal animated zoomIn" id="obj_29" data-refid="rouletteBall-29">29</span>
														</div>
														<div class="rouletteBall bgRed" id="rouletteBall-32">
															<canvas class="rteClickEventTop" id="obj_32_33" data-refid="rouletteBall-32~rouletteBall-33"></canvas>
															<canvas class="rteClickEventRht" id="obj_32_35" data-refid="rouletteBall-32~rouletteBall-35"></canvas>
															<canvas class="rteClickEventBtom" id="obj_31_32" data-refid="rouletteBall-31~rouletteBall-32"></canvas>
															<canvas class="Roucenter" id="obj_31_32_34_35" data-refid="rouletteBall-31~rouletteBall-32~rouletteBall-34~rouletteBall-35"></canvas>
															<span class="rteBallVal animated zoomIn" id="obj_32" data-refid="rouletteBall-32">32</span>
														</div>
														<div class="rouletteBall bgBlck" id="rouletteBall-35">
															<canvas class="rteClickEventTop" id="obj_35_36" data-refid="rouletteBall-35~rouletteBall-36"></canvas>
															<canvas class="rteClickEventRht" id="obj_35" data-refid="rouletteBall-35"></canvas>
															<canvas class="rteClickEventBtom" id="obj_34_35" data-refid="rouletteBall-34~rouletteBall-35"></canvas>
															<span class="rteBallVal animated zoomIn" data-refid="rouletteBall-35">35</span>
														</div>


														<div class="rouletteBall bgRed" id="rouletteBall-01">
															<canvas class="rteClickEventBtom" id="obj_01_02_03" data-refid="rouletteBall-01~rouletteBall-02~rouletteBall-03"></canvas>
															<canvas class="rteClickEventLft" id="obj_00_01" data-refid="rouletteBall-00~rouletteBall-01"></canvas>
															<canvas class="rteClickEventRht" id="obj_01_04" data-refid="rouletteBall-01~rouletteBall-04"></canvas>
															<canvas class="center1ForBall0" id="obj_00_01_02_03" data-refid="rouletteBall-00~rouletteBall-01~rouletteBall-02~rouletteBall-03"></canvas>
															<canvas class="Roucenter" id="obj_01_02_03_04_05_06" data-refid="rouletteBall-01~rouletteBall-02~rouletteBall-03~rouletteBall-04~rouletteBall-05~rouletteBall-06"></canvas>
															<span class="rteBallVal animated zoomIn" id="obj_01" data-refid="rouletteBall-01">1</span>
														</div>
														<div class="rouletteBall bgBlck" id="rouletteBall-04">
															<canvas class="rteClickEventRht" id="obj_04_07" data-refid="rouletteBall-04~rouletteBall-07"></canvas>
															<canvas class="rteClickEventBtom" id="obj_04_05_06" data-refid="rouletteBall-04~rouletteBall-05~rouletteBall-06"></canvas>
															<canvas class="Roucenter" id="obj_04_05_06_07_08_09" data-refid="rouletteBall-04~rouletteBall-05~rouletteBall-06~rouletteBall-07~rouletteBall-08~rouletteBall-09"></canvas>
															<span class="rteBallVal animated zoomIn" id="obj_04" data-refid="rouletteBall-04">4</span>
														</div>
														<div class="rouletteBall bgRed" id="rouletteBall-07">
															<canvas class="rteClickEventRht" id="obj_07_10" data-refid="rouletteBall-07~rouletteBall-10"></canvas>
															<canvas class="rteClickEventBtom" id="obj_07_08_09" data-refid="rouletteBall-07~rouletteBall-08~rouletteBall-09"></canvas>
															<canvas class="Roucenter" id="obj_07_08_09_10_11_12" data-refid="rouletteBall-07~rouletteBall-08~rouletteBall-09~rouletteBall-10~rouletteBall-11~rouletteBall-12"></canvas>
															<span class="rteBallVal animated zoomIn" id="obj_07" data-refid="rouletteBall-07">7</span>
														</div>
														<div class="rouletteBall bgBlck" id="rouletteBall-10">
															<canvas class="rteClickEventRht" id="obj_10_13" data-refid="rouletteBall-10~rouletteBall-13"></canvas>
															<canvas class="rteClickEventBtom" id="obj_10_11_12" data-refid="rouletteBall-10~rouletteBall-11~rouletteBall-12"></canvas>
															<canvas class="Roucenter" id="obj_10_11_12_13_14_15" data-refid="rouletteBall-10~rouletteBall-11~rouletteBall-12~rouletteBall-13~rouletteBall-14~rouletteBall-15"></canvas>
															<span class="rteBallVal animated zoomIn" id="obj_10" data-refid="rouletteBall-10">10</span>
														</div>
														<div class="rouletteBall bgBlck" id="rouletteBall-13">
															<canvas class="rteClickEventRht" id="obj_13_16" data-refid="rouletteBall-13~rouletteBall-16"></canvas>
															<canvas class="rteClickEventBtom" id="obj_13_14_15" data-refid="rouletteBall-13~rouletteBall-14~rouletteBall-15"></canvas>
															<canvas class="Roucenter" id="obj_13_14_15_16_17_18" data-refid="rouletteBall-13~rouletteBall-14~rouletteBall-15~rouletteBall-16~rouletteBall-17~rouletteBall-18"></canvas>
															<span class="rteBallVal animated zoomIn" id="obj_13" data-refid="rouletteBall-13">13</span>
														</div>
														<div class="rouletteBall bgRed" id="rouletteBall-16">
															<canvas class="rteClickEventRht" id="obj_16_19" data-refid="rouletteBall-16~rouletteBall-19"></canvas>
															<canvas class="rteClickEventBtom" id="obj_16_17_18" data-refid="rouletteBall-16~rouletteBall-17~rouletteBall-18"></canvas>
															<canvas class="Roucenter" id="obj_16_17_18_19_20_21" data-refid="rouletteBall-16~rouletteBall-17~rouletteBall-18~rouletteBall-19~rouletteBall-20~rouletteBall-21"></canvas>
															<span class="rteBallVal animated zoomIn" id="obj_16" data-refid="rouletteBall-16">16</span>
														</div>
														<div class="rouletteBall bgRed" id="rouletteBall-19">
															<canvas class="rteClickEventRht" id="obj_19_22" data-refid="rouletteBall-19~rouletteBall-22"></canvas>
															<canvas class="rteClickEventBtom" id="obj_19_20_21" data-refid="rouletteBall-19~rouletteBall-20~rouletteBall-21"></canvas>
															<canvas class="Roucenter" id="obj_19_20_21_22_23_24" data-refid="rouletteBall-19~rouletteBall-20~rouletteBall-21~rouletteBall-22~rouletteBall-23~rouletteBall-24"></canvas>
															<span class="rteBallVal animated zoomIn" id="obj_19" data-refid="rouletteBall-19">19</span>
														</div>
														<div class="rouletteBall bgBlck" id="rouletteBall-22">
															<canvas class="rteClickEventRht" id="obj_22_25" data-refid="rouletteBall-22~rouletteBall-25"></canvas>
															<canvas class="rteClickEventBtom" id="obj_22_23_24" data-refid="rouletteBall-22~rouletteBall-23~rouletteBall-24"></canvas>
															<canvas class="Roucenter" id="obj_22_23_24_25_26_27" data-refid="rouletteBall-22~rouletteBall-23~rouletteBall-24~rouletteBall-25~rouletteBall-26~rouletteBall-27"></canvas>
															<span class="rteBallVal animated zoomIn" id="obj_22" data-refid="rouletteBall-22">22</span>
														</div>
														<div class="rouletteBall bgRed" id="rouletteBall-25">
															<canvas class="rteClickEventRht" id="obj_25_28" data-refid="rouletteBall-25~rouletteBall-28"></canvas>
															<canvas class="rteClickEventBtom" id="obj_25_26_27" data-refid="rouletteBall-25~rouletteBall-26~rouletteBall-27"></canvas>
															<canvas class="Roucenter" id="obj_25_26_27_28_29_30" data-refid="rouletteBall-25~rouletteBall-26~rouletteBall-27~rouletteBall-28~rouletteBall-29~rouletteBall-30"></canvas>
															<span class="rteBallVal animated zoomIn" id="obj_25" data-refid="rouletteBall-25">25</span>
														</div>
														<div class="rouletteBall bgBlck" id="rouletteBall-28">
															<canvas class="rteClickEventRht" id="obj_28_31" data-refid="rouletteBall-28~rouletteBall-31"></canvas>
															<canvas class="rteClickEventBtom" id="obj_28_29_30" data-refid="rouletteBall-28~rouletteBall-29~rouletteBall-30"></canvas>
															<canvas class="Roucenter" id="obj_28_29_30_31_32_33" data-refid="rouletteBall-28~rouletteBall-29~rouletteBall-30~rouletteBall-31~rouletteBall-32~rouletteBall-33"></canvas>
															<span class="rteBallVal animated zoomIn" id="obj_28" data-refid="rouletteBall-28">28</span>
														</div>
														<div class="rouletteBall bgBlck" id="rouletteBall-31">
															<canvas class="rteClickEventRht" id="obj_31_34" data-refid="rouletteBall-31~rouletteBall-34"></canvas>
															<canvas class="rteClickEventBtom" id="obj_31_32_33" data-refid="rouletteBall-31~rouletteBall-32~rouletteBall-33"></canvas>
															<canvas class="Roucenter" id="obj_31_32_33_34_35_36" data-refid="rouletteBall-31~rouletteBall-32~rouletteBall-33~rouletteBall-34~rouletteBall-35~rouletteBall-36"></canvas>
															<span class="rteBallVal animated zoomIn" id="obj_31" data-refid="rouletteBall-31">31</span>
														</div>
														<div class="rouletteBall bgRed" id="rouletteBall-34">
															<canvas class="rteClickEventRht" id="obj_34" data-refid="rouletteBall-34"></canvas>
															<canvas class="rteClickEventBtom" id="obj_34_35_36" data-refid="rouletteBall-34~rouletteBall-35~rouletteBall-36"></canvas>
															<span class="rteBallVal animated zoomIn" data-refid="rouletteBall-34">34</span>
														</div>
													</div>
													<div class="rteBalContRht">
														<div class="rteBalContRhtBall">
															<span class="rteClickEventTop" data-dname="2to1 3" id="obj_03_06_09_12_15_18_21_24_27_30_33_36" data-refid="rouletteBall-03~rouletteBall-06~rouletteBall-09~rouletteBall-12~rouletteBall-15~rouletteBall-18~rouletteBall-21~rouletteBall-24~rouletteBall-27~rouletteBall-30~rouletteBall-33~rouletteBall-36"></span>
															<span class="rteClickEventRht" data-dname="2to1 3" data-refid="rouletteBall-03~rouletteBall-06~rouletteBall-09~rouletteBall-12~rouletteBall-15~rouletteBall-18~rouletteBall-21~rouletteBall-24~rouletteBall-27~rouletteBall-30~rouletteBall-33~rouletteBall-36"></span>
															<span class="rteBallValRhtInRht animated zoomIn" data-dname="2to1 3" data-refid="rouletteBall-03~rouletteBall-06~rouletteBall-09~rouletteBall-12~rouletteBall-15~rouletteBall-18~rouletteBall-21~rouletteBall-24~rouletteBall-27~rouletteBall-30~rouletteBall-33~rouletteBall-36">2<small>to</small>1</span>
														</div>
														<div class="rteBalContRhtBall">
															<span class="rteClickEventTop" data-dname="2to1 2" id="obj_02_05_08_11_14_17_20_23_26_29_32_35" data-refid="rouletteBall-02~rouletteBall-05~rouletteBall-08~rouletteBall-11~rouletteBall-14~rouletteBall-17~rouletteBall-20~rouletteBall-23~rouletteBall-26~rouletteBall-29~rouletteBall-32~rouletteBall-35"></span>
															<span class="rteClickEventRht" data-dname="2to1 2" data-refid="rouletteBall-02~rouletteBall-05~rouletteBall-08~rouletteBall-11~rouletteBall-14~rouletteBall-17~rouletteBall-20~rouletteBall-23~rouletteBall-26~rouletteBall-29~rouletteBall-32~rouletteBall-35"></span>
															<span class="rteClickEventBtom" data-dname="2to1 2" data-refid="rouletteBall-02~rouletteBall-05~rouletteBall-08~rouletteBall-11~rouletteBall-14~rouletteBall-17~rouletteBall-20~rouletteBall-23~rouletteBall-26~rouletteBall-29~rouletteBall-32~rouletteBall-35"></span>
															<span class="rteBallValRhtInRht animated zoomIn" data-dname="2to1 2" data-refid="rouletteBall-02~rouletteBall-05~rouletteBall-08~rouletteBall-11~rouletteBall-14~rouletteBall-17~rouletteBall-20~rouletteBall-23~rouletteBall-26~rouletteBall-29~rouletteBall-32~rouletteBall-35">2<small>to</small>1</span>
														</div>
														<div class="rteBalContRhtBall">
															<span class="rteClickEventRht" data-dname="2to1 1" id="obj_01_04_07_10_13_16_19_22_25_28_31_34" data-refid="rouletteBall-01~rouletteBall-04~rouletteBall-07~rouletteBall-10~rouletteBall-13~rouletteBall-16~rouletteBall-19~rouletteBall-22~rouletteBall-25~rouletteBall-28~rouletteBall-31~rouletteBall-34"></span>
															<span class="rteClickEventBtom" data-dname="2to1 1" data-refid="rouletteBall-01~rouletteBall-04~rouletteBall-07~rouletteBall-10~rouletteBall-13~rouletteBall-16~rouletteBall-19~rouletteBall-22~rouletteBall-25~rouletteBall-28~rouletteBall-31~rouletteBall-34"></span>
															<span class="rteBallValRhtInRht animated zoomIn" data-dname="2to1 1" data-refid="rouletteBall-01~rouletteBall-04~rouletteBall-07~rouletteBall-10~rouletteBall-13~rouletteBall-16~rouletteBall-19~rouletteBall-22~rouletteBall-25~rouletteBall-28~rouletteBall-31~rouletteBall-34">2<small>to</small>1</span>
														</div>
													</div>
													<div class="group4x4and2x2">
														<div class="group4x4Sec">
															<div class="group4x4">
																<span class="group4x4Cont" data-dname="1St to 12" id="obj_01_02_03_04_05_06_07_08_09_10_11_12" data-refid="rouletteBall-01~rouletteBall-02~rouletteBall-03~rouletteBall-04~rouletteBall-05~rouletteBall-06~rouletteBall-07~rouletteBall-08~rouletteBall-09~rouletteBall-10~rouletteBall-11~rouletteBall-12">1St to 12</span>
															</div>
															<div class="group4x4">
																<span class="group4x4Cont" data-dname="2rd to 12" id="obj_13_14_15_16_17_18_19_20_21_22_23_24" data-refid="rouletteBall-13~rouletteBall-14~rouletteBall-15~rouletteBall-16~rouletteBall-17~rouletteBall-18~rouletteBall-19~rouletteBall-20~rouletteBall-21~rouletteBall-22~rouletteBall-23~rouletteBall-24">2nd to 12</span>
															</div>
															<div class="group4x4">
																<span class="group4x4Cont" data-dname="3rd to 12" id="obj_25_26_27_28_29_30_31_32_33_34_35_36" data-refid="rouletteBall-25~rouletteBall-26~rouletteBall-27~rouletteBall-28~rouletteBall-29~rouletteBall-30~rouletteBall-31~rouletteBall-32~rouletteBall-33~rouletteBall-34~rouletteBall-35~rouletteBall-36">3rd to 12</span>
															</div>
														</div>
														<div class="group2x2Sec">
															<div class="group2x2">
																<span class="group2x2Cont" data-dname="1 to 18" id="obj_01_02_03_04_05_06_07_08_09_10_11_12_13_14_15_16_17_18" data-refid="rouletteBall-01~rouletteBall-02~rouletteBall-03~rouletteBall-04~rouletteBall-05~rouletteBall-06~rouletteBall-07~rouletteBall-08~rouletteBall-09~rouletteBall-10~rouletteBall-11~rouletteBall-12~rouletteBall-13~rouletteBall-14~rouletteBall-15~rouletteBall-16~rouletteBall-17~rouletteBall-18">1 to 18</span>
															</div>
															<div class="group2x2">
																<span class="group2x2Cont" data-dname="Even" id="obj_02_04_06_08_10_12_14_16_18_20_22_24_26_28_30_32_34_36" data-refid="rouletteBall-02~rouletteBall-04~rouletteBall-06~rouletteBall-08~rouletteBall-10~rouletteBall-12~rouletteBall-14~rouletteBall-16~rouletteBall-18~rouletteBall-20~rouletteBall-22~rouletteBall-24~rouletteBall-26~rouletteBall-28~rouletteBall-30~rouletteBall-32~rouletteBall-34~rouletteBall-36">Even</span>
															</div>
															<div class="group2x2 bgRed">
																<span class="group2x2Cont" data-dname="Red" id="obj_01_03_05_07_09_12_14_16_18_19_21_23_25_27_30_32_34_36" data-refid="rouletteBall-01~rouletteBall-03~rouletteBall-05~rouletteBall-07~rouletteBall-09~rouletteBall-12~rouletteBall-14~rouletteBall-16~rouletteBall-18~rouletteBall-19~rouletteBall-21~rouletteBall-23~rouletteBall-25~rouletteBall-27~rouletteBall-30~rouletteBall-32~rouletteBall-34~rouletteBall-36"></span>
															</div>
															<div class="group2x2 bgBlck">
																<span class="group2x2Cont" data-dname="Black" id="obj_02_04_06_08_10_11_13_15_17_20_22_24_26_28_29_31_33_35" data-refid="rouletteBall-02~rouletteBall-04~rouletteBall-06~rouletteBall-08~rouletteBall-10~rouletteBall-11~rouletteBall-13~rouletteBall-15~rouletteBall-17~rouletteBall-20~rouletteBall-22~rouletteBall-24~rouletteBall-26~rouletteBall-28~rouletteBall-29~rouletteBall-31~rouletteBall-33~rouletteBall-35"></span>
															</div>
															<div class="group2x2">
																<span class="group2x2Cont" data-dname="Odd" id="obj_01_03_05_07_09_11_13_15_17_19_21_23_25_27_29_31_33_35" data-refid="rouletteBall-01~rouletteBall-03~rouletteBall-05~rouletteBall-07~rouletteBall-09~rouletteBall-11~rouletteBall-13~rouletteBall-15~rouletteBall-17~rouletteBall-19~rouletteBall-21~rouletteBall-23~rouletteBall-25~rouletteBall-27~rouletteBall-29~rouletteBall-31~rouletteBall-33~rouletteBall-35">Odd</span>
															</div>
															<div class="group2x2">
																<span class="group2x2Cont" data-dname="19 to 36" id="obj_19_20_21_22_23_24_25_26_27_28_29_30_31_32_33_34_35_36" data-refid="rouletteBall-19~rouletteBall-20~rouletteBall-21~rouletteBall-22~rouletteBall-23~rouletteBall-24~rouletteBall-25~rouletteBall-26~rouletteBall-27~rouletteBall-28~rouletteBall-29~rouletteBall-30~rouletteBall-31~rouletteBall-32~rouletteBall-33~rouletteBall-34~rouletteBall-35~rouletteBall-36">19 to 36</span>
															</div>
														</div>
													</div>
													<div id="tooltipBallVal">
														<div class="tooltipCont">
															<img src="./assets/img/icons/deSelect.webp" />
														</div>
													</div>
													<div class="betUndo" title="Pick the Coin">
														<img src="./assets/img/roulette/close.png" />
													</div>
												</div>
											</div>
											<div class="coinsSec">
												<div class="coins">
													<div class="chipDoller">
														USD :
													</div>
													<ul class="coinsCont">
														<li>
															<div class="coinsImg5000" id="coin5000">
																<span class="coinsVal">25</span>
															</div>
														</li>
														<li>
															<div class="coinsImg1000" id="coin1000">
																<span class="coinsVal">10</span>
															</div>
														</li>
														<li>
															<div class="coinsImg500" id="coin500">
																<span class="coinsVal">5</span>
															</div>
														</li>
														<li>
															<div class="coinsImg100" id="coin100">
																<span class="coinsVal">2</span>
															</div>
														</li>
														<li>
															<div class="coinsImg50" id="coin50">
																<span class="coinsVal">1.5</span>
															</div>
														</li>
														<li>
															<div class="coinsImg10" id="coin10">
																<span class="coinsVal">1</span>
															</div>
														</li>
														<li class="coinSelImgActive animated zoomIn">
															<div class="coinsImg1" id="coin1">
																<span class="coinsVal">0.5</span>
															</div>
														</li>
													</ul>
												</div>
												{/* <div class="BuyBtn">
													<a onClick={() => { this.BuyLotteryBet() }}>Buy</a>
												</div> */}
											</div>

											<div class="rteOvel">
												<div class="rteOvelContainer">
													<div class="rteOvelCont">
														<div class="rteOvelContLft">
															<div class="rteOvelContLftInr">
																<div class="rteOvelContLft-Ball ovelTblBall bgRed" id="rteOvelTblBall-05">
																	<span class="rteOvelBallVal" data-refid="rteOvelTblBall-05~rteOvelTblBall-10~rteOvelTblBall-23~rteOvelTblBall-24~rteOvelTblBall-16">5</span>
																</div>
																<div class="rteOvelContLft-Ball ovelTblBall bgBlck" id="rteOvelTblBall-10">
																	<span class="rteOvelBallVal" data-refid="rteOvelTblBall-10~rteOvelTblBall-23~rteOvelTblBall-08~rteOvelTblBall-05~rteOvelTblBall-24">10</span>
																</div>
																<div class="rteOvelContLft-Ball ovelTblBall bgRed" id="rteOvelTblBall-23">
																	<span class="rteOvelBallVal" data-refid="rteOvelTblBall-23~rteOvelTblBall-10~rteOvelTblBall-05~rteOvelTblBall-08~rteOvelTblBall-30">23</span>
																</div>
																<div class="rteOvelContLft-Ball ovelTblBall bgBlck" id="rteOvelTblBall-08">
																	<span class="rteOvelBallVal" data-refid="rteOvelTblBall-08~rteOvelTblBall-23~rteOvelTblBall-10~rteOvelTblBall-30~rteOvelTblBall-11">8</span>
																</div>
																<div class="rteOvelContLft-Ball ovelTblBall bgRed" id="rteOvelTblBall-30">
																	<span class="rteOvelBallVal" data-refid="rteOvelTblBall-30~rteOvelTblBall-08~rteOvelTblBall-23~rteOvelTblBall-11~rteOvelTblBall-36">30</span>
																</div>
																<div class="rteOvelContLft-Ball ovelTblBall bgBlck" id="rteOvelTblBall-11">
																	<span class="rteOvelBallVal" data-refid="rteOvelTblBall-11~rteOvelTblBall-30~rteOvelTblBall-08~rteOvelTblBall-36~rteOvelTblBall-13">11</span>
																</div>
															</div>
														</div>
														<div class="rteOvelContTier">
															<div class="rteOvelContTierInr">
																<div class="rteOvelContTierInrTop">
																	<div class="rteOvelContTierInrTop-Ball ovelTblBall bgBlck" id="rteOvelTblBall-24">
																		<span class="rteOvelBallVal" data-refid="rteOvelTblBall-24~rteOvelTblBall-05~rteOvelTblBall-10~rteOvelTblBall-16~rteOvelTblBall-33">24</span>
																	</div>
																	<div class="rteOvelContTierInrTop-Ball ovelTblBall bgRed" id="rteOvelTblBall-16">
																		<span class="rteOvelBallVal" data-refid="rteOvelTblBall-16~rteOvelTblBall-24~rteOvelTblBall-05~rteOvelTblBall-33~rteOvelTblBall-01">16</span>
																	</div>
																	<div class="rteOvelContTierInrTop-Ball ovelTblBall bgBlck" id="rteOvelTblBall-33">
																		<span class="rteOvelBallVal" data-refid="rteOvelTblBall-33~rteOvelTblBall-16~rteOvelTblBall-24~rteOvelTblBall-01~rteOvelTblBall-20">33</span>
																	</div>
																</div>
																<div class="rteOvelContTierInrCent">
																	<span class="ovelCentLft" data-cid="1" data-refid="rteOvelTblBall-05~rteOvelTblBall-08~rteOvelTblBall-10~rteOvelTblBall-11~rteOvelTblBall-13~rteOvelTblBall-16~rteOvelTblBall-23~rteOvelTblBall-24~rteOvelTblBall-27~rteOvelTblBall-30~rteOvelTblBall-33~rteOvelTblBall-36">TIER</span>
																</div>
																<div class="rteOvelContTierInrBtom">
																	<div class="rteOvelContTierInrBtom-Ball ovelTblBall bgRed" id="rteOvelTblBall-36">
																		<span class="rteOvelBallVal" data-refid="rteOvelTblBall-36~rteOvelTblBall-11~rteOvelTblBall-30~rteOvelTblBall-13~rteOvelTblBall-27">36</span>
																	</div>
																	<div class="rteOvelContTierInrBtom-Ball ovelTblBall bgBlck" id="rteOvelTblBall-13">
																		<span class="rteOvelBallVal" data-refid="rteOvelTblBall-13~rteOvelTblBall-36~rteOvelTblBall-11~rteOvelTblBall-27~rteOvelTblBall-06">13</span>
																	</div>
																	<div class="rteOvelContTierInrBtom-Ball ovelTblBall bgRed" id="rteOvelTblBall-27">
																		<span class="rteOvelBallVal" data-refid="rteOvelTblBall-27~rteOvelTblBall-13~rteOvelTblBall-36~rteOvelTblBall-06~rteOvelTblBall-34">27</span>
																	</div>
																</div>
															</div>
														</div>
														<div class="rteOvelContOrphns">
															<div class="rteOvelContOrphnsInr">
																<div class="rteOvelContOrphnsTop">
																	<div class="rteOvelContOrphnsTop-Ball ovelTblBall bgRed" id="rteOvelTblBall-01">
																		<span class="rteOvelBallVal" data-refid="rteOvelTblBall-01~rteOvelTblBall-33~rteOvelTblBall-16~rteOvelTblBall-20~rteOvelTblBall-14">1</span>
																	</div>
																	<div class="rteOvelContOrphnsTop-Ball ovelTblBall bgBlck" id="rteOvelTblBall-20">
																		<span class="rteOvelBallVal" data-refid="rteOvelTblBall-20~rteOvelTblBall-01~rteOvelTblBall-33~rteOvelTblBall-14~rteOvelTblBall-31">20</span>
																	</div>
																	<div class="rteOvelContOrphnsTop-Ball ovelTblBall bgRed" id="rteOvelTblBall-14">
																		<span class="rteOvelBallVal" data-refid="rteOvelTblBall-14~rteOvelTblBall-20~rteOvelTblBall-01~rteOvelTblBall-31~rteOvelTblBall-09">14</span>
																	</div>
																	<div class="rteOvelContOrphnsTop-Ball ovelTblBall bgBlck" id="rteOvelTblBall-31">
																		<span class="rteOvelBallVal" data-refid="rteOvelTblBall-31~rteOvelTblBall-14~rteOvelTblBall-20~rteOvelTblBall-09~rteOvelTblBall-22">31</span>
																	</div>
																	<div class="rteOvelContOrphnsTop-Ball ovelTblBall bgRed" id="rteOvelTblBall-09">
																		<span class="rteOvelBallVal" data-refid="rteOvelTblBall-09~rteOvelTblBall-31~rteOvelTblBall-14~rteOvelTblBall-22~rteOvelTblBall-18">9</span>
																	</div>
																</div>
																<div class="rteOvelContOrphnsCent">
																	<span class="OrphnsCent" data-cid="2" data-refid="rteOvelTblBall-01~rteOvelTblBall-06~rteOvelTblBall-09~rteOvelTblBall-14~rteOvelTblBall-17~rteOvelTblBall-20~rteOvelTblBall-31~rteOvelTblBall-34">ORPHELINS</span>
																</div>
																<div class="rteOvelContOrphnsBtom">
																	<div class="rteOvelContOrphnsBtom-Ball ovelTblBall bgBlck" id="rteOvelTblBall-06">
																		<span class="rteOvelBallVal" data-refid="rteOvelTblBall-06~rteOvelTblBall-27~rteOvelTblBall-13~rteOvelTblBall-34~rteOvelTblBall-17">6</span>
																	</div>
																	<div class="rteOvelContOrphnsBtom-Ball ovelTblBall bgRed" id="rteOvelTblBall-34">
																		<span class="rteOvelBallVal" data-refid="rteOvelTblBall-34~rteOvelTblBall-06~rteOvelTblBall-27~rteOvelTblBall-17~rteOvelTblBall-25">34</span>
																	</div>
																	<div class="rteOvelContOrphnsBtom-Ball ovelTblBall bgBlck" id="rteOvelTblBall-17">
																		<span class="rteOvelBallVal" data-refid="rteOvelTblBall-17~rteOvelTblBall-34~rteOvelTblBall-06~rteOvelTblBall-25~rteOvelTblBall-02">17</span>
																	</div>
																</div>
															</div>
														</div>
														<div class="vision">
															<div class="visionInr">
																<div class="visionTop">
																	<div class="visionTop-Ball ovelTblBall bgBlck" id="rteOvelTblBall-22">
																		<span class="rteOvelBallVal" data-refid="rteOvelTblBall-22~rteOvelTblBall-09~rteOvelTblBall-31~rteOvelTblBall-18~rteOvelTblBall-29">22</span>
																	</div>
																	<div class="visionTop-Ball ovelTblBall bgRed" id="rteOvelTblBall-18">
																		<span class="rteOvelBallVal" data-refid="rteOvelTblBall-18~rteOvelTblBall-22~rteOvelTblBall-09~rteOvelTblBall-29~rteOvelTblBall-07">18</span>
																	</div>
																	<div class="visionTop-Ball ovelTblBall bgBlck" id="rteOvelTblBall-29">
																		<span class="rteOvelBallVal" data-refid="rteOvelTblBall-29~rteOvelTblBall-18~rteOvelTblBall-22~rteOvelTblBall-07~rteOvelTblBall-28">29</span>
																	</div>
																	<div class="visionTop-Ball ovelTblBall bgRed" id="rteOvelTblBall-07">
																		<span class="rteOvelBallVal" data-refid="rteOvelTblBall-07~rteOvelTblBall-29~rteOvelTblBall-18~rteOvelTblBall-28~rteOvelTblBall-12">7</span>
																	</div>
																	<div class="visionTop-Ball ovelTblBall bgBlck" id="rteOvelTblBall-28">
																		<span class="rteOvelBallVal" data-refid="rteOvelTblBall-28~rteOvelTblBall-07~rteOvelTblBall-29~rteOvelTblBall-12~rteOvelTblBall-35">28</span>
																	</div>
																	<div class="visionTop-Ball ovelTblBall bgRed" id="rteOvelTblBall-12">
																		<span class="rteOvelBallVal" data-refid="rteOvelTblBall-12~rteOvelTblBall-28~rteOvelTblBall-07~rteOvelTblBall-35~rteOvelTblBall-03">12</span>
																	</div>
																</div>
																<div class="visionCent">
																	<span class="ovelCentLft " data-cid="3" data-refid="rteOvelTblBall-00~rteOvelTblBall-02~rteOvelTblBall-03~rteOvelTblBall-04~rteOvelTblBall-07~rteOvelTblBall-12~rteOvelTblBall-15~rteOvelTblBall-18~rteOvelTblBall-19~rteOvelTblBall-21~rteOvelTblBall-22~rteOvelTblBall-25~rteOvelTblBall-26~rteOvelTblBall-28~rteOvelTblBall-29~rteOvelTblBall-32~rteOvelTblBall-35">VOISINS</span>
																</div>
																<div class="zero">
																	<span class="ovelCentLft" data-cid="4" data-refid="rteOvelTblBall-00~rteOvelTblBall-03~rteOvelTblBall-12~rteOvelTblBall-15~rteOvelTblBall-26~rteOvelTblBall-32~rteOvelTblBall-35">ZERO</span>
																</div>
																<div class="visionBtom">
																	<div class="visionBtom-Ball ovelTblBall bgRed" id="rteOvelTblBall-25">
																		<span class="rteOvelBallVal" data-refid="rteOvelTblBall-25~rteOvelTblBall-17~rteOvelTblBall-34~rteOvelTblBall-02~rteOvelTblBall-21">25</span>
																	</div>
																	<div class="visionBtom-Ball ovelTblBall bgBlck" id="rteOvelTblBall-02">
																		<span class="rteOvelBallVal" data-refid="rteOvelTblBall-02~rteOvelTblBall-25~rteOvelTblBall-17~rteOvelTblBall-21~rteOvelTblBall-04">2</span>
																	</div>
																	<div class="visionBtom-Ball ovelTblBall bgRed" id="rteOvelTblBall-21">
																		<span class="rteOvelBallVal" data-refid="rteOvelTblBall-21~rteOvelTblBall-02~rteOvelTblBall-25~rteOvelTblBall-04~rteOvelTblBall-19">21</span>
																	</div>
																	<div class="visionBtom-Ball ovelTblBall bgBlck" id="rteOvelTblBall-04">
																		<span class="rteOvelBallVal" data-refid="rteOvelTblBall-04~rteOvelTblBall-21~rteOvelTblBall-02~rteOvelTblBall-19~rteOvelTblBall-15">4</span>
																	</div>
																	<div class="visionBtom-Ball ovelTblBall bgRed" id="rteOvelTblBall-19">
																		<span class="rteOvelBallVal" data-refid="rteOvelTblBall-19~rteOvelTblBall-04~rteOvelTblBall-21~rteOvelTblBall-15~rteOvelTblBall-32">19</span>
																	</div>
																	<div class="visionBtom-Ball ovelTblBall bgBlck" id="rteOvelTblBall-15">
																		<span class="rteOvelBallVal" data-refid="rteOvelTblBall-15~rteOvelTblBall-19~rteOvelTblBall-04~rteOvelTblBall-32~rteOvelTblBall-00">15</span>
																	</div>
																</div>
															</div>
														</div>
														<div class="rteOvelContRht">
															<div class="rteOvelContRhtInr">
																<div class="rteOvelContRht-Ball ovelTblBall bgBlck" id="rteOvelTblBall-35">
																	<span class="rteOvelBallVal" data-refid="rteOvelTblBall-35~rteOvelTblBall-12~rteOvelTblBall-28~rteOvelTblBall-03~rteOvelTblBall-26">35</span>
																</div>
																<div class="rteOvelContRht-Ball ovelTblBall bgRed" id="rteOvelTblBall-03">
																	<span class="rteOvelBallVal" data-refid="rteOvelTblBall-03~rteOvelTblBall-12~rteOvelTblBall-35~rteOvelTblBall-26~rteOvelTblBall-00">3</span>
																</div>
																<div class="rteOvelContRht-Ball ovelTblBall bgBlck" id="rteOvelTblBall-26">
																	<span class="rteOvelBallVal" data-refid="rteOvelTblBall-26~rteOvelTblBall-03~rteOvelTblBall-35~rteOvelTblBall-00~rteOvelTblBall-32">26</span>
																</div>
																<div class="rteOvelContRht-Ball ovelTblBall bgGreen" id="rteOvelTblBall-00">
																	<span class="rteOvelBallVal" data-refid="rteOvelTblBall-00~rteOvelTblBall-26~rteOvelTblBall-03~rteOvelTblBall-32~rteOvelTblBall-15">0</span>
																</div>
																<div class="rteOvelContRht-Ball ovelTblBall bgRed" id="rteOvelTblBall-32">
																	<span class="rteOvelBallVal" data-refid="rteOvelTblBall-32~rteOvelTblBall-15~rteOvelTblBall-19~rteOvelTblBall-00~rteOvelTblBall-26">32</span>
																</div>
															</div>
														</div>
													</div>
												</div>
												<div class="spList">
													<div class="spListCont">
														<span class="spListContLi bgRed" data-cid="5" data-refid="rteOvelTblBall-09~rteOvelTblBall-12~rteOvelTblBall-16~rteOvelTblBall-18~rteOvelTblBall-19~rteOvelTblBall-21~rteOvelTblBall-27~rteOvelTblBall-30">Red Split</span>
														<span class="spListContLi bgBlck" data-cid="6" data-refid="rteOvelTblBall-08~rteOvelTblBall-10~rteOvelTblBall-11~rteOvelTblBall-13~rteOvelTblBall-17~rteOvelTblBall-20~rteOvelTblBall-26~rteOvelTblBall-28~rteOvelTblBall-29~rteOvelTblBall-31">Black Split</span>
														<div class="instantBtn">
															<RouletteRight buyLotteryBet={this.BuyLotteryBet} clearCart={this.clearCart} removeFromCart={this.removeFromCart} latestResult={this.state.latestRouletteResult} />
														</div>
													</div>
												</div>
												<div class="inOutMaxValue" id="maxValInfo">
													Inner Max Value : 100 / Outer Max Value : 1000
												</div>
											</div>

										</div>
									</div>
								</div>
							</div>
							<RouletteLeft selectDraw={this.selectDraw} currentAvailableDraws={this.state.currentAvailableDraws} reCount={this.reCount(this.state.currentRunningDraw)} />
						</div>
					</div>
					{/* <RouletteRight buyLotteryBet={this.BuyLotteryBet} clearCart={this.clearCart} removeFromCart={this.removeFromCart} latestResult={this.state.latestRouletteResult} /> */}
				</div>
			</>

		)
	};
}

function mapStateToProps(state) {
	const { currentAvailableDraws, latestRouletteResult, cartItems, currentDraw, currentResult } = state.gameReducer;
	const { serverTime } = state.commonReducer;
	const { user } = state.loginReducer;
	const { ResultReport } = state.accountReducer;
	return { ResultReport, user, currentAvailableDraws, cartItems, currentDraw, serverTime, latestRouletteResult, currentResult };
}

const mapActionToProps = {
	GameFamily: gameActions.GameFamily,
	GameAvailableGamesRoulete: gameActions.GameAvailableGamesRoulete,
	AddToCartRoulette: gameActions.AddToCartRoulette,
	RemoveFromCart: gameActions.RemoveFromCart,
	RemoveClosedDrawbetFromCart: gameActions.RemoveClosedDrawbetFromCart,
	SetCurrentDraw: gameActions.SetCurrentDraw,
	ClearCart: gameActions.ClearCart,
	BuybetRoulete: gameActions.BuybetRoulete,
	GetRouletteResult: gameActions.GetRouletteResult,
	GetCurrentResultRoulete: accountActions.GetCurrentResultRoulete,
	ClearAvailableGames: gameActions.ClearAvailableGames,
	UpdateCartAll: gameActions.UpdateCartAll,
}

export default connect(mapStateToProps, mapActionToProps)(withTranslation()(Roulette))